<template>
  <UiAdditionalInformation path="/tilleggsopplysninger/informasjonskapsler">
    <p class="extra-cookies-data--link">
      Ønsker du å endre hvilke ikke-nødvendige informasjonskapsler du godtar på
      våre nettsider
      <a class="cky-banner-element">kan du gjøre det her</a>.
    </p>
    <div class="cky-audit-table-element extra-cookies-data--table" />
  </UiAdditionalInformation>
</template>

<style scoped>
.extra-cookies-data--link,
.extra-cookies-data--table {
  margin: 0 auto 2rem auto;
  font-size: 1.2rem;
  color: var(--color-green-40);

  a {
    color: var(--color-green-40);
    text-decoration: underline;
    cursor: pointer;
    font-weight: 600;
  }
}

.extra-cookies-data--table {
  margin: 0 auto 6rem auto;
}
</style>
